import React, { useEffect, useState, useMemo } from "react";
import ShopsItem from "../components/ShopsItem";
import { NOTIFICATIONS_API } from "../components/apiurls";

export const PageNotifications = () => {
  const [notificationIds, setNotificationIds] = useState([]);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const userMobile = localStorage.getItem("userMobile");

    if (!userMobile) return;

    const payload = {
      action: "list",      // 👈 list notifications
      user_mobile: userMobile,
    };

    // ✅ Console log request
    console.log("NOTIFICATION LIST PAYLOAD:", payload);

    fetch(NOTIFICATIONS_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        console.log("NOTIFICATION LIST RESPONSE:", data);

        if (Array.isArray(data)) {
          setNotifications(data);
          setNotificationIds(data);
        }
      })
      .catch(err => console.error("Notification List Error:", err));
  }, []);

  return (
    <div className="products-card notification-page" style={{ marginTop: "60px" }}>
      {notificationIds.length === 0 ? (
        <p>No notification items</p>
      ) : (
        <ShopsItem
          isNotificationPage={true}
          notificationIds={notificationIds}
        />
      )}
    </div>
  );
};